import { planTypes } from "@/common/constants";

export default {
  data() {
    return {
      logo: require("@/assets/plans/icon_ZM.svg"),
      title: this.$t("billing.planform.title.zoom_one_biz_plus"),
      planType: planTypes.ZOOM_ONE_BUNDLE,
    };
  },
};
